import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';

export default function useDealers(props) {
    const {dealerName} = props
    
    const {
        data: dealer,
        isLoading: loadingDealer,
        error: errorDealer,
        refetch: refetchDealer,
    } = useProtectedQuery({
        queryKey: ['get_dealer',],
        queryFn: async () => {
            let url = `/api/dealer/get-dealer?dealerName=${dealerName}`;


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting dealer");
            }

        },
    });


    return {
        dealer,
        loadingDealer,
        errorDealer,
        refetchDealer,
    }
}
